export enum DashboardTypes {
  Accounts = 'accounts',
  Users = 'users',
  Teams = 'teams'
}

export enum PageSizeOptionsTypes {
  ItemOne = '25',
  ItemTwo = '50',
  ItemThree = '100'
}

export enum SelectionsTypes {
  Selection = 'Selection',
  SelectPage = 'Select page',
  SelectAll = 'Select all',
  ClearSelection = 'Clear selection',
}

export interface IndexableObject {
  [key: string]: string | number | Date | null;
}

export interface IPaginationTable {
  currentPage: number;
  pageSize: number;
  totalCount: number;
}

export interface State {
  filterMenuVisibility: string;
  selectedRowKeys: React.Key[];
  selectedRowKeysGroupedByPage: ISelectedRowKeysGroupedByPage[];
}

export interface ISelectedRowKeysGroupedByPage {
  page: number;
  ids: React.Key[];
  exceptIds: React.Key[];
}

export interface IRowKeys {
  selectedRowKeys: React.Key[];
  areAllPagesSelected: boolean;
}

export const ACCOUNT_ACCESS = 'accountAccess';